import { Platform, StyleSheet } from "react-native";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { theme } from "../../../theme/theme";
const style = ({ tradename }) => {
    const { colorBgActionPrimaryActive, colorBgInteractiveSelected, colorBorderInput, fontMap, fontDetailSize1 } = theme();
    const thumbSize = 24;
    const primaryColor = tradename === Tradename.LOOKIERO ? colorBgInteractiveSelected : colorBgActionPrimaryActive;
    const secondaryColor = colorBorderInput;
    const styles = StyleSheet.create({
        sliderContainer: {
            position: "relative",
            width: "100%",
            ...Platform.select({
                web: {
                    touchAction: "none",
                },
            }),
        },
        thumbText: {
            fontFamily: fontMap.DetailBold,
            fontSize: fontDetailSize1,
            textAlign: "center",
        },
        thumbTextContainer: {
            bottom: Platform.select({
                ios: thumbSize * 1.75,
                default: thumbSize,
            }),
            position: "absolute",
        },
        track: {
            ...Platform.select({
                android: {
                    alignSelf: "stretch",
                    marginHorizontal: -(thumbSize / 2),
                },
                default: { width: "100%" },
            }),
        },
    });
    return {
        ...styles,
        thumbSize,
        primaryColor,
        secondaryColor,
    };
};
export { style };
